import "./index.css";

interface TitleProps {
  text: string;
  type: TemplateType;
  style?: React.CSSProperties;
}

const Title = (props: TitleProps) => {
  const { text, style = {}, type } = props;

  const formatText = (text: string) => ({
    __html: text.replace(/\n/g, "<br>"),
  });

  return <div className={`base-title base-title-${type}`} style={style} dangerouslySetInnerHTML={formatText(text)} />;
};

export default Title;
